import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


const COLOR_POSITIVE_DARK = '#30E0A1';
const COLOR_NEGATIVE_DARK = 'red';
const COLOR_POSITIVE_LIGHT = '#059669';
const COLOR_NEGATIVE_LIGHT = '#DC2626';

const ChartJs = (props) => {
    let {data, current, diff = 0, isLightTheme = false} = props;
    const colorPositive = isLightTheme ? COLOR_POSITIVE_LIGHT : COLOR_POSITIVE_DARK;
    const colorNegative = isLightTheme ? COLOR_NEGATIVE_LIGHT : COLOR_NEGATIVE_DARK;
    const lineColor = Math.sign(diff) === -1 ? colorNegative : colorPositive;

    let options = {
        responsive: true,
        animation: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                displayColors: false,
                titleAlign: 'center',
                bodyAlign: 'center',
                bodyColor: lineColor,
                callbacks: {
                    // use label callback to return the desired label
                    label: function(tooltipItem, data) {
                        return tooltipItem.formattedValue
                    },
                    labelColor: function() {
                        return {
                            backgroundColor: lineColor
                        }
                    },

                },
                borderColor: lineColor,
            },
        },
        elements: {
            line: {
                tension: 0.4
            }
        },
        scales: {
            y: {
                display: false // Hide Y axis labels
            },
            x: {
                display: false // Hide X axis labels
            }
        },

        title: {
            display: false
        },
    };
   /* ChartJS.options.elements.line.tension = 0.4;*/

    let labels = data && data.data && data.data.length > 0 && data.data.map((elem) => elem.date) || [];
    let dataChart = {
        labels,
        datasets: [
            {
                label: '',
                data: data && data.data && data.data.length > 0 && data.data.map((elem) => elem[`${current}`]) || [],
                borderColor: lineColor,
                backgroundColor: 'transparent',
            },
        ],
    };
    return (
        <div>
            <Line options={options} data={dataChart || []}/>
        </div>
    );
};

export default ChartJs;